/**
 * Using an enclosure because of Drupals default use of noConflict in jQuery
 */
(function ($)
{
    /**
     * When the document is ready.
     */
    $(document).ready(function ()
    {

        var hideSearchDrop = function ()
            {
                $('.searchTypeDropDown').hide();
                $('#myTes-wrapper').removeClass('send-to-back');
                $('.searchType .searchArrow').show();
            },
            hideMyDrop = function ()
            {
                $('.myTesDropDown').hide();
                $("#personalLinks a.fn").removeClass('selected');

            };

        var selectedSearch = $('#header form.search select').val(),
            dropdownTimeout = 1000;

        $('#header #search').keypress(function (e)
        {
            var $this = $(this),
                searchVal = $.trim($this.val());

            if (e.which === 13) {
                e.preventDefault();

                if (searchVal.length > 0) {
                    $this.val(searchVal);
                    $this[0].form.submit();
                }

                return false;
            }
        });

        $(function ()
        {
            var _cookie_banner = $("#cookie-banner");
            $(".btn", _cookie_banner).bind('click', function ()
            {

                var _cookie_name = 'TES_Compliance';
                var _cookie_value = '';
                var _ctime = parseInt($("input#ctime").val());
                var _domain = $("input#domain").val();
                var _date_value = $("input#serverDT").val();
                var _date = new Date();
                var $myTesWrapperSelector = $(document.getElementById('myTes-wrapper'));
                var slideUpCallback = function ()
                {
                    if ($myTesWrapperSelector.hasClass('is-open')) {
                        $('#cookie-banner .btn').trigger("cookies-accepted");
                    }
                    else {
                        $myTesWrapperSelector.show();
                    }
                };
                _date.setFullYear(_date_value.substring(6, 10));
                _date.setMonth((_date_value.substring(3, 5) * 1) - 1);
                _date.setDate(_date_value.substring(0, 2));
                _date.setHours(_date_value.substring(11, 13));
                _date.setMinutes(_date_value.substring(14, 16));
                _date.setSeconds(_date_value.substring(17, 19));
                _date.setDate(_date.getDate() + _ctime)
                document.cookie = _cookie_name + "=" + _cookie_value + ";expires=" + _date.toUTCString() + ";domain=" + _domain + ";path=/";
                $myTesWrapperSelector.removeClass('enable-cookie').hide();
                _cookie_banner.slideUp({duration: 600, queue: false, complete: slideUpCallback});
            });
        });


        $('#header form.search select option').each(function ()
        {
            $('.searchTypeDropDown ul').append('<li><a href="#" class="' + $(this).val() + '">' + $(this).text() + '</a></li>');
        });

        $('.searchTypeDropDown ul a').click(function (evt)
        {
            evt.preventDefault();
            $('#header form.search select').val($(this).attr('class'));
            $('.searchTypeContainer').attr('class', 'searchTypeContainer').addClass($(this).attr('class'));
            $('.searchType').html('<span class="glass"></span>' + $(this).text() + '<span class="searchArrow"></span>');
            $('.searchTypeDropDown').hide()
                .find('li').removeClass('hide');
            $('#header input.search').focus();
        });

        var searchTimer;
        $('.searchTypeDropDown').mouseout(function ()
        {
            searchTimer = setTimeout(hideSearchDrop, dropdownTimeout);
        }).mouseover(function ()
        {
            clearTimeout(searchTimer);
        });

        $('.searchType').click(function (evt)
        {
            evt.preventDefault();
            if (!$('.searchTypeDropDown').is(":visible")) {
                var currentSelectedSearch = $('#header form.search select').val();
                $(".searchTypeDropDown ." + currentSelectedSearch).parent('li').addClass('hide');
            }
            $('#myTes-wrapper').toggleClass('send-to-back');
            $('.searchType .searchArrow').toggle();
            $('.searchTypeDropDown').toggle();
        });

        /* Maintain browser's select state */
        $('.searchType').html('<span class="glass"></span>' + $('.searchTypeContainer .' + selectedSearch).text() + '<span class="searchArrow"></span>');
        $('.searchTypeContainer').attr('class', 'searchTypeContainer').addClass(selectedSearch);

        $('#personalLinks a.fn, .searchType, .myTesDropDown, .searchTypeDropDown').keyup(function (evt)
        {
            if (evt && evt.keyCode === 27) { /* ESCAPE */
                hideMyDrop();
                hideSearchDrop();
            }
        });

        $('#personalLinks a.fn').click(function (evt)
        {
            evt.preventDefault();
            if (!$(this).parent().hasClass('disabled')) {
                $('.myTesDropDown').toggle();
                $(this).toggleClass('selected');
            }
        });
        var myTimer;
        $('.myTesDropDown').mouseout(function ()
        {
            myTimer = setTimeout("hideMyDrop()", dropdownTimeout);
        }).mouseover(function ()
        {
            clearTimeout(myTimer);
        });

        $('body').click(function (evt)
        {

            if ($activeUcpMnu !== null) {
                if (($(evt.target).closest("#personalLinks").length === 0)) {
                    $activeUcpMnu.removeClass("active");
                    $activeUcpMnu = null;
                }
            }
            if (!$(evt.target).is('#personName, .personArrow')) {

                hideMyDrop();

            }

            if (!$(evt.target).is('.searchType, .glass, .searchArrow')) {
                hideSearchDrop();
            }

        });

        $('input.search, a.inbox').focus(function ()
        {
            hideSearchDrop();
            hideMyDrop();
        });

        $('ul#personalLinks li').hover(
            function ()
            {
                $(this).find('.tab').addClass("active");
            }, function ()
            {
                $(this).find('.tab').removeClass("active");
            }
        );

        $('ul#personalLinks li').bind("click", function ()
        {
            $(this).find('.tab').removeClass("active");
        });

        //Once CSS fix is found this will be removed
        $(".ie7 #progress").css("width", function ()
        {
            return $("#personalLinks").find(".profileDetails").outerWidth();
        });
        $(".profileGroup .ucpMnu").css("width", function ()
        {

            return $(".profileGroup a").outerWidth();
        });

        var $activeUcpMnu = null;


    });
}(jQuery));
